module["exports"] = [
  "visa",
  "mastercard",
  "americanexpress",
  "discover"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/business/credit_card_types.js
// module id = 908
// module chunks = 0